import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import baseUrl from "../../api/baseUrl";
import DeleteDialog from "../../components/modal/delete/DeleteDialog";
import InputText from "../../components/inputs/InputText";
import DropInput from "../../components/inputs/DropInput";
import RadioInput from "../../components/inputs/RadioInput";
import ImputImage from "../../components/inputs/ImputImage";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../redux/loader/loaderActions";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-number-input";
import socket from "../../api/socket";
import { patienttitles } from "../../utils/title";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PersonIcon from "@mui/icons-material/Person";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import SaveIcon from "@mui/icons-material/Save";

const ALLERGY_TYPES = [
  { id: "penicillin", label: "Penicillin (and other beta-lactams)" },
  { id: "cloxacillin", label: "Cloxacillin" },
  { id: "aspirinNsaids", label: "Aspirin and other NSAIDs" },
  { id: "diclofenac", label: "Diclofenac" },
  { id: "carbamazepine", label: "Carbamazepine" },
  { id: "localAnaesthesia", label: "Local anaesthesia" },
  { id: "otherDrugs", label: "Other drugs" },
  { id: "foodBeverage", label: "Food/beverage allergies" },
] as const;

type AllergyItem = { id: string; label: string; note: string; dosage?: string; diagnosedWhen?: string };

const DIABETES_DRUG_TYPES = [
  { id: "metformin", label: "Metformin" },
  { id: "gliclazide", label: "Gliclazide" },
  { id: "insulinPreparations", label: "Insulin preparations" },
] as const;

type DiabetesDrugItem = { id: string; label: string; note: string; dosage?: string; diagnosedWhen?: string };

const HYPERTENSION_DRUG_TYPES = [
  { id: "aceInhibitors", label: "ACE Inhibitors (Captopril, Enalapril)" },
  { id: "losartan", label: "Losartan" },
  { id: "amlodipine", label: "Amlodipine" },
  { id: "furosemide", label: "Furosemide" },
  { id: "methyldopa", label: "Methyldopa" },
  { id: "other", label: "Other" },
] as const;

type HypertensionDrugItem = { id: string; label: string; note: string };

const DYSLIPIDEMIA_DRUG_TYPES = [
  { id: "atorvastatin", label: "Atorvastatin" },
  { id: "rosuvastatin", label: "Rosuvastatin" },
  { id: "fibrates", label: "Fibrates" },
  { id: "other", label: "Other" },
] as const;

type DyslipidemiaDrugItem = { id: string; label: string; note: string };

function FullregisterPatient() {
  const [isDisable, setDisable] = useState(false);
  const [erors, seterors] = useState(false);
  const dispatch = useDispatch();
  const { ID } = useParams();
  const navigate = useNavigate();

  const hanldeChangeDisable = () => {
    if (isDisable) {
      toast("You can now Edit");
      setDisable(!isDisable);
    } else {
      setDisable(!isDisable);
    }
  };

  const [formData, setformData] = useState({
    registerdDate: "",
    fullName: "",
    gender: "",
    maritalStatus: "",
    dob: "",
    religion: "",
    whatsapp: "",
    smobileNo: "",
    otherNo: "",
    occupation: "",
    bloodGroup: "",
    image: null as string | ArrayBuffer | null,
    images: "",
    nic: "",
    title: "",
    email: "",
    mobileNo: "",
    telNo: "",
    address: "",
    nameOfIntroduce: "",
    vaccinated: "",
    patientType: "",
    allergies: { status: "false", note: "", items: [] as AllergyItem[] },
    diabetesMellitusDrugs: { status: "false", note: "", items: [] as DiabetesDrugItem[] },
    hypertensionDrugs: { status: "false", note: "", items: [] as HypertensionDrugItem[] },
    dyslipidemiaDrugs: { status: "false", note: "", items: [] as DyslipidemiaDrugItem[] },
    gastricProblem: { status: "false", note: "" },
    highBP: { status: "false", note: "" },
    diabetes: { status: "false", note: "" },
    monthlyInjection: { status: "false", note: "" },
    pregnancyBreastFeeding: { status: "false", note: "" },
    coughColdFever: { status: "false", note: "" },
    chestpainHeartProblem: { status: "false", note: "" },
    epilepsy: { status: "false", note: "" },
    previousExtraction: { status: "false", note: "" },
    previoussurgeries: { status: "false", note: "" },
    covid193Doses: { status: "false", note: "" },
    drugHistory: { status: "false", note: "" },
    dietaryHistory: { status: "false", note: "" },
    brushingHistory: { status: "false", note: "" },
    extraOralExamination: "",
    intraOralExamination: "",
    medicalHistoryNote: { status: "false", note: "" },
    oralHygieneHistory: { status: "false", note: "" },
    habitHistory: { status: "false", note: "" },
    familyHistory: { status: "false", note: "" },
    socialHistory: { status: "false", note: "" },
  });

  const [selectNavigate, setSelectNavigate] = useState<any>(0);
  const [active, setactive] = useState(false);

  /* Contact number exists check - when user types 5+ digits */
  const [contactNumberStatus, setContactNumberStatus] = useState<null | "checking" | "exists" | "not_exists">(null);
  const [contactNumberFoundPatients, setContactNumberFoundPatients] = useState<any[]>([]);
  const contactNumberDebounceRef = React.useRef<NodeJS.Timeout | null>(null);
  const contactNumberDropdownRef = React.useRef<HTMLDivElement>(null);

  const handleSelectNavugate = (i: any) => {
    if (i === 1) {
      if (
        formData.title === "" &&
        formData.fullName === "" &&
        formData.gender === "" &&
        formData.mobileNo === ""
      ) {
        seterors(true);
      } else {
        seterors(false);
        setSelectNavigate(i);
      }
    } else {
      setSelectNavigate(i);
    }
  };

  const onsubmit = (e: any) => {
    e.preventDefault();
    if (ID) {
      dispatch(setloadeActive());
      baseUrl
        .put("patient/update", formData, { headers: { patientid: ID } })
        .then((response) => {
          if (response.data.success) {
            dispatch(setloadeDeactive());
            toast.success("Patient Updated Successfully");
            navigate("/client/patients/patients-list/active");
          }
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    } else {
      dispatch(setloadeActive());
      baseUrl
        .post("patient/full-register", formData)
        .then((response) => {
          if (response.data.success) {
            dispatch(setloadeDeactive());
            navigate("/client/patients/patients-list/active");
            toast.success("Patient Registered Successfully");
            socket.emit("addpatients", response.data.data);
          }
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (ID) {
      dispatch(setloadeActive());
      setDisable(true);
      baseUrl
        .get("patient/findById", { headers: { patientid: ID } })
        .then((response) => {
          const item = response.data.data;
          dispatch(setloadeDeactive());
          if (ID) {
            setactive(item?.status);

            setformData({
              registerdDate: item?.registerdDate?.split("T")[0] ?? "",
              fullName: item?.fullName ?? "",
              gender: item?.gender ?? "",
              dob: item?.dob?.split("T")[0] ?? "",
              religion: item?.religion ?? "",
              whatsapp: item?.whatsapp ?? "",
              smobileNo: item?.smobileNo ?? "",
              maritalStatus: item?.maritalStatus ?? "",
              otherNo: item?.otherNo ?? "",
              occupation: item?.occupation ?? "",
              bloodGroup: item?.bloodGroup ?? "",
              image: null as string | ArrayBuffer | null,
              images: item?.image ?? "",
              nic: item?.nic ?? "",
              title: item?.title ?? "",
              email: item?.email ?? "",
              mobileNo: item?.mobileNo ?? "",
              telNo: item?.telNo ?? "",
              address: item?.address ?? "",
              nameOfIntroduce: item?.nameOfIntroduce ?? "",
              vaccinated: item?.vaccinated ?? "",
              patientType: item?.patientType ?? "",
              allergies: (() => {
                const a = item?.allergies;
                if (!a) return { status: "false", note: "", items: [] as AllergyItem[] };
                const status = String(a?.status ?? "false");
                if (Array.isArray((a as any)?.items) && (a as any).items.length > 0) {
                  const items: AllergyItem[] = (a as any).items.map((x: any) => ({
                    id: x?.id ?? "",
                    label: x?.label ?? ALLERGY_TYPES.find((t) => t.id === x?.id)?.label ?? x?.id ?? "",
                    note: x?.note ?? "",
                    dosage: x?.dosage ?? "",
                    diagnosedWhen: x?.diagnosedWhen ?? "",
                  }));
                  return { status, note: (a as any)?.note ?? "", items };
                }
                const items: AllergyItem[] = [];
                if (status === "true" && (a as any)?.note) {
                  items.push({
                    id: "otherDrugs",
                    label: "Other drugs",
                    note: (a as any).note,
                    dosage: "",
                    diagnosedWhen: "",
                  });
                }
                return { status, note: (a as any)?.note ?? "", items };
              })(),
              diabetesMellitusDrugs: (() => {
                const d = item?.diabetesMellitusDrugs;
                if (!d) return { status: "false", note: "", items: [] as DiabetesDrugItem[] };
                const status = String(d?.status ?? "false");
                if (Array.isArray((d as any)?.items) && (d as any).items.length > 0) {
                  const items: DiabetesDrugItem[] = (d as any).items.map((x: any) => ({
                    id: x?.id ?? "",
                    label: x?.label ?? DIABETES_DRUG_TYPES.find((t) => t.id === x?.id)?.label ?? x?.id ?? "",
                    note: x?.note ?? "",
                    dosage: x?.dosage ?? "",
                    diagnosedWhen: x?.diagnosedWhen ?? "",
                  }));
                  return { status, note: (d as any)?.note ?? "", items };
                }
                const items: DiabetesDrugItem[] = [];
                if (status === "true" && (d as any)?.note) {
                  items.push({
                    id: "metformin",
                    label: "Metformin",
                    note: (d as any).note,
                    dosage: "",
                    diagnosedWhen: "",
                  });
                }
                return { status, note: (d as any)?.note ?? "", items };
              })(),
              hypertensionDrugs: (() => {
                const h = item?.hypertensionDrugs;
                if (!h) return { status: "false", note: "", items: [] as HypertensionDrugItem[] };
                const status = String(h?.status ?? "false");
                if (Array.isArray((h as any)?.items) && (h as any).items.length > 0) {
                  const items: HypertensionDrugItem[] = (h as any).items.map((x: any) => ({
                    id: x?.id ?? "",
                    label: x?.label ?? HYPERTENSION_DRUG_TYPES.find((t) => t.id === x?.id)?.label ?? x?.id ?? "",
                    note: x?.note ?? "",
                  }));
                  return { status, note: (h as any)?.note ?? "", items };
                }
                const items: HypertensionDrugItem[] = [];
                if (status === "true" && (h as any)?.note) {
                  items.push({
                    id: "other",
                    label: "Other",
                    note: (h as any).note,
                  });
                }
                return { status, note: (h as any)?.note ?? "", items };
              })(),
              dyslipidemiaDrugs: (() => {
                const d = item?.dyslipidemiaDrugs;
                if (!d) return { status: "false", note: "", items: [] as DyslipidemiaDrugItem[] };
                const status = String(d?.status ?? "false");
                if (Array.isArray((d as any)?.items) && (d as any).items.length > 0) {
                  const items: DyslipidemiaDrugItem[] = (d as any).items.map((x: any) => ({
                    id: x?.id ?? "",
                    label: x?.label ?? DYSLIPIDEMIA_DRUG_TYPES.find((t) => t.id === x?.id)?.label ?? x?.id ?? "",
                    note: x?.note ?? "",
                  }));
                  return { status, note: (d as any)?.note ?? "", items };
                }
                const items: DyslipidemiaDrugItem[] = [];
                if (status === "true" && (d as any)?.note) {
                  items.push({
                    id: "other",
                    label: "Other",
                    note: (d as any).note,
                  });
                }
                return { status, note: (d as any)?.note ?? "", items };
              })(),
              gastricProblem: item?.gastricProblem,
              highBP: item?.highBP,
              diabetes: item?.diabetes,
              monthlyInjection: item?.monthlyInjection,
              pregnancyBreastFeeding: item?.pregnancyBreastFeeding,
              coughColdFever: item?.coughColdFever,
              chestpainHeartProblem: item?.chestpainHeartProblem,
              epilepsy: item?.epilepsy,
              previousExtraction: item?.previousExtraction,
              previoussurgeries: item?.previoussurgeries,
              covid193Doses: item?.covid193Doses,
              drugHistory: item?.drugHistory,
              dietaryHistory: item?.dietaryHistory,
              brushingHistory: item?.brushingHistory,
              extraOralExamination: item?.extraOralExamination ?? "",
              intraOralExamination: item?.intraOralExamination ?? "",
              medicalHistoryNote: typeof item?.medicalHistoryNote === "object" && item?.medicalHistoryNote !== null
                ? { status: String((item.medicalHistoryNote as any)?.status ?? "false"), note: (item.medicalHistoryNote as any)?.note ?? "" }
                : { status: "false", note: "" },
              oralHygieneHistory: typeof item?.oralHygieneHistory === "object" && item?.oralHygieneHistory !== null
                ? { status: String((item.oralHygieneHistory as any)?.status ?? "false"), note: (item.oralHygieneHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
              habitHistory: typeof item?.habitHistory === "object" && item?.habitHistory !== null
                ? { status: String((item.habitHistory as any)?.status ?? "false"), note: (item.habitHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
              familyHistory: typeof item?.familyHistory === "object" && item?.familyHistory !== null
                ? { status: String((item.familyHistory as any)?.status ?? "false"), note: (item.familyHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
              socialHistory: typeof item?.socialHistory === "object" && item?.socialHistory !== null
                ? { status: String((item.socialHistory as any)?.status ?? "false"), note: (item.socialHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
            });
          }
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    }
  }, [ID, dispatch]);

  const handleChange = async (e: any) => {
    const { name, value, type } = e.target;
    if (type === "radio") {
      setformData({
        ...formData,
        [name]: { note: e.target.note, status: e.target.status },
      });
    } else if (type === "file") {
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            setformData({
              ...formData,
              image: reader.result as string,
              [name]: e.target.files[0],
            });
          }
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      setformData({ ...formData, [name]: value });
    }
  };

  const [deleteOpen, setdeleteOpen] = useState(false);

  const onDelete = () => {
    setdeleteOpen(true);
  };

  const confirmDelete = () => {
    if (ID) {
      baseUrl
        .delete("patient/delete", { headers: { patientid: ID } })
        .then((response) => {
          setdeleteOpen(false);
          navigate("/client/patients/patients-list/active");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const activePatient = () => {
    if (ID) {
      baseUrl
        .delete("patient/active", { headers: { patientid: ID } })
        .then((response) => {
          setdeleteOpen(false);
          navigate("/client/patients/patients-list/active");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handlePhonenumber = (e: any) => {
    setformData({ ...formData, [e.name]: e.value });

    if (e.name === "mobileNo") {
      const raw = (e.value || "").replace(/\D/g, "");
      if (contactNumberDebounceRef.current) clearTimeout(contactNumberDebounceRef.current);
      setContactNumberStatus(null);
      setContactNumberFoundPatients([]);
      if (raw.length < 5) return;
      setContactNumberStatus("checking");
      contactNumberDebounceRef.current = setTimeout(() => {
        baseUrl
          .post("client/patient/find-patients-by-phonenumber", { phonenumber: e.value })
          .then((res) => {
            if (!res.data.success || !Array.isArray(res.data.data)) {
              setContactNumberStatus("not_exists");
              setContactNumberFoundPatients([]);
              return;
            }
            const patients = res.data.data;
            const isCurrentPatient = (p: any) => ID && (p._id === ID || p.id === ID);
            const others = patients.filter((p: any) => !isCurrentPatient(p));
            setContactNumberFoundPatients(others);
            setContactNumberStatus(others.length > 0 ? "exists" : "not_exists");
          })
          .catch(() => {
            setContactNumberStatus("not_exists");
            setContactNumberFoundPatients([]);
          })
          .finally(() => {
            contactNumberDebounceRef.current = null;
          });
      }, 400);
    }
  };

  useEffect(() => {
    return () => {
      if (contactNumberDebounceRef.current) clearTimeout(contactNumberDebounceRef.current);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        contactNumberDropdownRef.current &&
        !contactNumberDropdownRef.current.contains(event.target as Node)
      ) {
        setContactNumberStatus(null);
        setContactNumberFoundPatients([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const setAllergiesStatus = (status: "true" | "false") => {
    setformData({
      ...formData,
      allergies: {
        status,
        note: status === "false" ? "" : formData.allergies.note,
        items: status === "false" ? [] : formData.allergies.items,
      },
    });
  };

  const [allergyAddTypeId, setAllergyAddTypeId] = useState("");
  const [allergyAddNote, setAllergyAddNote] = useState("");
  const [allergyAddDosage, setAllergyAddDosage] = useState("");
  const [allergyAddDiagnosedWhen, setAllergyAddDiagnosedWhen] = useState("");

  const addAllergyEntry = () => {
    if (!allergyAddTypeId) return;
    const type = ALLERGY_TYPES.find((t) => t.id === allergyAddTypeId);
    const label = type?.label ?? allergyAddTypeId;
    setformData({
      ...formData,
      allergies: {
        ...formData.allergies,
        items: [...formData.allergies.items, {
          id: allergyAddTypeId,
          label,
          note: allergyAddNote,
          dosage: allergyAddDosage,
          diagnosedWhen: allergyAddDiagnosedWhen,
        }],
      },
    });
    setAllergyAddTypeId("");
    setAllergyAddNote("");
    setAllergyAddDosage("");
    setAllergyAddDiagnosedWhen("");
  };

  const removeAllergyEntry = (index: number) => {
    const items = formData.allergies.items.filter((_, i) => i !== index);
    setformData({ ...formData, allergies: { ...formData.allergies, items } });
  };

  const setDiabetesDrugsStatus = (status: "true" | "false") => {
    setformData({
      ...formData,
      diabetesMellitusDrugs: {
        status,
        note: status === "false" ? "" : formData.diabetesMellitusDrugs.note,
        items: status === "false" ? [] : formData.diabetesMellitusDrugs.items,
      },
    });
  };

  const [diabetesDrugAddTypeId, setDiabetesDrugAddTypeId] = useState("");
  const [diabetesDrugAddNote, setDiabetesDrugAddNote] = useState("");
  const [diabetesDrugAddDosage, setDiabetesDrugAddDosage] = useState("");
  const [diabetesDrugAddDiagnosedWhen, setDiabetesDrugAddDiagnosedWhen] = useState("");

  const addDiabetesDrugEntry = () => {
    if (!diabetesDrugAddTypeId) return;
    const type = DIABETES_DRUG_TYPES.find((t) => t.id === diabetesDrugAddTypeId);
    const label = type?.label ?? diabetesDrugAddTypeId;
    setformData({
      ...formData,
      diabetesMellitusDrugs: {
        ...formData.diabetesMellitusDrugs,
        items: [...formData.diabetesMellitusDrugs.items, {
          id: diabetesDrugAddTypeId,
          label,
          note: diabetesDrugAddNote,
          dosage: diabetesDrugAddDosage,
          diagnosedWhen: diabetesDrugAddDiagnosedWhen,
        }],
      },
    });
    setDiabetesDrugAddTypeId("");
    setDiabetesDrugAddNote("");
    setDiabetesDrugAddDosage("");
    setDiabetesDrugAddDiagnosedWhen("");
  };

  const removeDiabetesDrugEntry = (index: number) => {
    const items = formData.diabetesMellitusDrugs.items.filter((_, i) => i !== index);
    setformData({ ...formData, diabetesMellitusDrugs: { ...formData.diabetesMellitusDrugs, items } });
  };

  const setHypertensionDrugsStatus = (status: "true" | "false") => {
    setformData({
      ...formData,
      hypertensionDrugs: {
        status,
        note: status === "false" ? "" : formData.hypertensionDrugs.note,
        items: status === "false" ? [] : formData.hypertensionDrugs.items,
      },
    });
  };

  const [hypertensionDrugAddTypeId, setHypertensionDrugAddTypeId] = useState("");
  const [hypertensionDrugAddNote, setHypertensionDrugAddNote] = useState("");

  const addHypertensionDrugEntry = () => {
    if (!hypertensionDrugAddTypeId) return;
    const type = HYPERTENSION_DRUG_TYPES.find((t) => t.id === hypertensionDrugAddTypeId);
    const label = type?.label ?? hypertensionDrugAddTypeId;
    setformData({
      ...formData,
      hypertensionDrugs: {
        ...formData.hypertensionDrugs,
        items: [...formData.hypertensionDrugs.items, { id: hypertensionDrugAddTypeId, label, note: hypertensionDrugAddNote }],
      },
    });
    setHypertensionDrugAddTypeId("");
    setHypertensionDrugAddNote("");
  };

  const removeHypertensionDrugEntry = (index: number) => {
    const items = formData.hypertensionDrugs.items.filter((_, i) => i !== index);
    setformData({ ...formData, hypertensionDrugs: { ...formData.hypertensionDrugs, items } });
  };

  const setDyslipidemiaDrugsStatus = (status: "true" | "false") => {
    setformData({
      ...formData,
      dyslipidemiaDrugs: {
        status,
        note: status === "false" ? "" : formData.dyslipidemiaDrugs.note,
        items: status === "false" ? [] : formData.dyslipidemiaDrugs.items,
      },
    });
  };

  const [dyslipidemiaDrugAddTypeId, setDyslipidemiaDrugAddTypeId] = useState("");
  const [dyslipidemiaDrugAddNote, setDyslipidemiaDrugAddNote] = useState("");

  const addDyslipidemiaDrugEntry = () => {
    if (!dyslipidemiaDrugAddTypeId) return;
    const type = DYSLIPIDEMIA_DRUG_TYPES.find((t) => t.id === dyslipidemiaDrugAddTypeId);
    const label = type?.label ?? dyslipidemiaDrugAddTypeId;
    setformData({
      ...formData,
      dyslipidemiaDrugs: {
        ...formData.dyslipidemiaDrugs,
        items: [...formData.dyslipidemiaDrugs.items, { id: dyslipidemiaDrugAddTypeId, label, note: dyslipidemiaDrugAddNote }],
      },
    });
    setDyslipidemiaDrugAddTypeId("");
    setDyslipidemiaDrugAddNote("");
  };

  const removeDyslipidemiaDrugEntry = (index: number) => {
    const items = formData.dyslipidemiaDrugs.items.filter((_, i) => i !== index);
    setformData({ ...formData, dyslipidemiaDrugs: { ...formData.dyslipidemiaDrugs, items } });
  };

  return (
    <div className="">
      <style>{`
        .form__field {
          height: 32px !important;
          padding: 0px 12px !important;
          font-size: 12px !important;
        }
        .form__label {
          font-size: 12px !important;
        }
      `}</style>
      {deleteOpen && (
        <DeleteDialog
          onDelete={() => confirmDelete()}
          onCancel={() => setdeleteOpen(false)}
        />
      )}

      {/* Navigation Tabs & Actions */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          {/* Tab Buttons */}
          <div className="flex gap-2">
            <button
              onClick={() => handleSelectNavugate(0)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-lg font-medium text-xs transition-all ${selectNavigate === 0
                ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-lg shadow-primary/30"
                : "bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600"
                }`}
            >
              <PersonIcon sx={{ fontSize: 16 }} />
              General Details
            </button>
            <button
              onClick={() => handleSelectNavugate(1)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-lg font-medium text-xs transition-all ${selectNavigate === 1
                ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-lg shadow-primary/30"
                : "bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600"
                }`}
            >
              <MedicalServicesIcon sx={{ fontSize: 16 }} />
              Medical History
            </button>
          </div>

          {/* Action Buttons */}
          {ID && (
            <div className="flex gap-2">
              {active ? (
                <button
                  onClick={() => onDelete()}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg font-medium text-xs hover:bg-red-100 dark:hover:bg-red-900/50 transition-colors"
                >
                  <DeleteIcon sx={{ fontSize: 16 }} />
                  Deactivate
                </button>
              ) : (
                <button
                  onClick={() => activePatient()}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-lg font-medium text-xs hover:bg-emerald-100 dark:hover:bg-emerald-900/50 transition-colors"
                >
                  <CheckCircleIcon sx={{ fontSize: 16 }} />
                  Activate
                </button>
              )}
              <button
                onClick={hanldeChangeDisable}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 rounded-lg font-medium text-xs hover:bg-amber-100 dark:hover:bg-amber-900/50 transition-colors"
              >
                <EditIcon sx={{ fontSize: 16 }} />
                Edit
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Form */}
      <form
        onSubmit={onsubmit}
        onKeyDown={(e) => {
          if (e.key !== "Enter") return;
          const target = e.target as HTMLElement;
          const tag = target?.tagName;
          if (tag === "TEXTAREA") return;
          const type = (target as HTMLButtonElement)?.type;
          if (tag === "BUTTON" && type === "submit") return;
          e.preventDefault();
        }}
      >
        <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
          {selectNavigate === 0 ? (
            /* General Details */
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4">
              {/* Left Column - 8 fields */}
              <div className="flex flex-col gap-4">
                {/* Contact Number - top left */}
                <div
                  ref={contactNumberDropdownRef}
                  className="flex flex-col items-start gap-1.5 w-full my-1.5 relative"
                >
                  <label className="block text-sm font-normal capitalize text-slate-700 dark:text-slate-300">
                    Contact Number
                  </label>
                  <div className="w-full min-h-[2.5rem] [&_.PhoneInput]:!min-h-10 [&_.PhoneInput]:h-10 [&_.PhoneInput]:bg-slate-50 dark:[&_.PhoneInput]:bg-slate-700 [&_.PhoneInput]:border [&_.PhoneInput]:border-gray-600 dark:[&_.PhoneInput]:border-slate-600 [&_.PhoneInput]:rounded-md [&_.PhoneInput]:px-3 [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:text-sm [&_.PhoneInputInput]:text-slate-800 dark:[&_.PhoneInputInput]:text-slate-200">
                    <PhoneInput
                      disabled={isDisable}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="LK"
                      value={formData.mobileNo}
                      onChange={(e) =>
                        handlePhonenumber({ value: e, name: "mobileNo" })
                      }
                    />
                  </div>
                  {contactNumberStatus && (
                    <div
                      className="absolute top-full left-0 right-0 z-10 mt-0.5 rounded-md border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 shadow-lg overflow-hidden"
                    >
                      {contactNumberStatus === "checking" && (
                        <div className="py-2 px-3 text-xs text-slate-500 dark:text-slate-400 flex items-center gap-2">
                          <span className="w-3.5 h-3.5 border-2 border-slate-400 border-t-transparent rounded-full animate-spin" />
                          Checking...
                        </div>
                      )}
                      {contactNumberStatus === "exists" && contactNumberFoundPatients.length > 0 && (
                        <div className="max-h-48 overflow-y-auto py-1 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-slate-100 dark:[&::-webkit-scrollbar-track]:bg-slate-700 [&::-webkit-scrollbar-thumb]:bg-slate-300 dark:[&::-webkit-scrollbar-thumb]:bg-slate-500 [&::-webkit-scrollbar-thumb]:rounded-full">
                          <p className="px-3 py-1.5 text-[10px] font-semibold text-amber-600 dark:text-amber-400 uppercase tracking-wide">
                            Already registered
                          </p>
                          {contactNumberFoundPatients.map((patient: any, index: number) => (
                            <div
                              key={patient._id || index}
                              className="px-3 py-2 border-t border-slate-100 dark:border-slate-600 first:border-t-0"
                            >
                              <p className="text-xs font-semibold text-slate-800 dark:text-slate-100">
                                {patient.fullName || "—"}
                              </p>
                              <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1 text-[11px] text-slate-600 dark:text-slate-400">
                                {patient.regNo != null && patient.regNo !== "" && (
                                  <span>Reg: {patient.regNo}</span>
                                )}
                                {patient.mobileNo && (
                                  <span>{patient.mobileNo}</span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {contactNumberStatus === "not_exists" && (
                        <div className="py-2 px-3 text-xs text-green-600 dark:text-green-400 font-medium">
                          Available
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Full Name */}
                <div className="flex flex-col items-start gap-1.5 w-full my-1.5">
                  <label className="block text-sm font-normal capitalize text-slate-700 dark:text-slate-300">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-2 w-full">
                    <select
                      disabled={isDisable}
                      name="title"
                      onChange={handleChange}
                      value={formData.title}
                      required={true}
                      className={`h-10 min-w-[80px] px-3 bg-slate-50 dark:bg-slate-700 border rounded-md outline-none transition-all text-sm text-slate-700 dark:text-slate-200 ${erors && formData.title === ""
                        ? "border-red-500"
                        : "border-gray-600 dark:border-slate-600"
                        }`}
                    >
                      <option value="">Title</option>
                      {patienttitles.map((item: any, i: number) => (
                        <option key={i} value={item.value}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      disabled={isDisable}
                      name="fullName"
                      onChange={handleChange}
                      value={formData.fullName}
                      required={true}
                      className={`flex-1 h-10 px-3 bg-slate-50 dark:bg-slate-700 border rounded-md outline-none transition-all text-sm text-slate-800 dark:text-slate-200 ${erors && formData.fullName === ""
                        ? "border-red-500"
                        : "border-gray-600 dark:border-slate-600"
                        }`}
                    />
                  </div>
                  {erors &&
                    (formData.fullName === "" || formData.title === "") && (
                      <p className="text-xs text-red-500">
                        Full Name is mandatory
                      </p>
                    )}
                </div>
                <DropInput
                  isDisable={isDisable}
                  name="gender"
                  onChange={handleChange}
                  value={formData.gender}
                  label="Gender"
                  className="endDot"
                  required={true}
                  errors={formData.gender === "" && erors}
                  option={[
                    { name: "Male", value: "male" },
                    { name: "Female", value: "female" },
                    { name: "Other", value: "other" },
                  ]}
                />
                <InputText
                  isDisable={isDisable}
                  name="dob"
                  onChange={handleChange}
                  value={formData.dob}
                  label="Date Of Birth"
                  type="date"
                />
                <InputText
                  isDisable={isDisable}
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  label="Address"
                />
                <InputText
                  isDisable={isDisable}
                  name="nic"
                  onChange={handleChange}
                  value={formData.nic}
                  label="NIC Number"
                />





                <DropInput
                  isDisable={isDisable}
                  name="maritalStatus"
                  onChange={handleChange}
                  value={formData.maritalStatus}
                  label="Marital Status"
                  option={[
                    { name: "Married", value: "Married" },
                    { name: "Single", value: "Single" },
                  ]}
                />

                <DropInput
                  isDisable={isDisable}
                  name="religion"
                  onChange={handleChange}
                  value={formData.religion}
                  label="Religion"
                  option={[
                    { name: "Christiant", value: "christiant" },
                    { name: "Buddhist", value: "buddhist" },
                    { name: "Muslims", value: "muslims" },
                    { name: "Hindu", value: "hindu" },
                  ]}
                />
                <ImputImage
                  isDisable={isDisable}
                  name="images"
                  onChange={handleChange}
                  value={formData.images}
                  imageback={formData.image}
                  label="Photo Attachment"
                  type="file"
                />

              </div>

              {/* Right Column - 8 fields */}
              <div className="flex flex-col gap-4">
                <DropInput
                  isDisable={isDisable}
                  name="bloodGroup"
                  onChange={handleChange}
                  value={formData.bloodGroup}
                  label="Blood Group"
                  option={[
                    { name: "A+", value: "A+" },
                    { name: "O+", value: "O+" },
                    { name: "B+", value: "B+" },
                    { name: "AB+", value: "AB+" },
                    { name: "A-", value: "A-" },
                    { name: "O-", value: "O-" },
                    { name: "B-", value: "B-" },
                    { name: "AB-", value: "AB-" },
                  ]}
                />

                {/* WhatsApp */}
                <div className="flex flex-col items-start gap-1.5 w-full my-1.5">
                  <label className="block text-sm font-normal capitalize text-slate-700 dark:text-slate-300">
                    WhatsApp Number
                  </label>
                  <div className="w-full min-h-[2.5rem] [&_.PhoneInput]:!min-h-10 [&_.PhoneInput]:h-10 [&_.PhoneInput]:bg-slate-50 dark:[&_.PhoneInput]:bg-slate-700 [&_.PhoneInput]:border [&_.PhoneInput]:border-gray-600 dark:[&_.PhoneInput]:border-slate-600 [&_.PhoneInput]:rounded-md [&_.PhoneInput]:px-3 [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:text-sm [&_.PhoneInputInput]:text-slate-800 dark:[&_.PhoneInputInput]:text-slate-200">
                    <PhoneInput
                      disabled={isDisable}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="LK"
                      value={formData.whatsapp}
                      onChange={(e) =>
                        handlePhonenumber({ value: e, name: "whatsapp" })
                      }
                    />
                  </div>
                </div>

                {/* Secondary Number */}
                <div className="flex flex-col items-start gap-1.5 w-full my-1.5">
                  <label className="block text-sm font-normal capitalize text-slate-700 dark:text-slate-300">
                    Secondary Number
                  </label>
                  <div className="w-full min-h-[2.5rem] [&_.PhoneInput]:!min-h-10 [&_.PhoneInput]:h-10 [&_.PhoneInput]:bg-slate-50 dark:[&_.PhoneInput]:bg-slate-700 [&_.PhoneInput]:border [&_.PhoneInput]:border-gray-600 dark:[&_.PhoneInput]:border-slate-600 [&_.PhoneInput]:rounded-md [&_.PhoneInput]:px-3 [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:text-sm [&_.PhoneInputInput]:text-slate-800 dark:[&_.PhoneInputInput]:text-slate-200">
                    <PhoneInput
                      disabled={isDisable}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="LK"
                      value={formData.smobileNo}
                      onChange={(e) =>
                        handlePhonenumber({ value: e, name: "smobileNo" })
                      }
                    />
                  </div>
                </div>

                <InputText
                  isDisable={isDisable}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  label="Email Address"
                  type="email"
                />
                <InputText
                  isDisable={isDisable}
                  name="occupation"
                  onChange={handleChange}
                  value={formData.occupation}
                  label="Occupation"
                  type="text"
                />

                <DropInput
                  isDisable={isDisable}
                  name="nameOfIntroduce"
                  onChange={handleChange}
                  value={formData.nameOfIntroduce}
                  label="Mode Of Introduction"
                  option={[
                    { name: "From Friends", value: "friends" },
                    { name: "Facebook", value: "facebook" },
                    { name: "Other", value: "other" },
                  ]}
                />

                <DropInput
                  isDisable={isDisable}
                  name="patientType"
                  onChange={handleChange}
                  value={formData.patientType}
                  label="Patient Type"
                  option={[
                    { name: "VVIP", value: "VVIP" },
                    { name: "VIP", value: "VIP" },
                    { name: "Normal", value: "Normal" },
                  ]}
                />

                {/* Right side bottom: Registered Date then Address */}
                <InputText
                  isDisable={isDisable}
                  name="registerdDate"
                  type="date"
                  onChange={handleChange}
                  value={formData.registerdDate}
                  label="Registered Date"
                />

              </div>


            </div>
          ) : (
            /* Medical History */
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {/* Left Column */}
              <div className="space-y-3">
                {/* Allergies: Yes/No → when Yes, note table opens */}
                <div className="flex flex-col gap-2.5 mb-5">
                  <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                    Allergies
                  </label>
                  <div className="flex items-center gap-5">
                    <div
                      role="group"
                      aria-label="Allergies - Yes or No"
                      className={`relative inline-flex p-0.5 rounded-lg border bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-600 ${isDisable ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                    >
                      <div
                        className={`absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-md bg-white dark:bg-slate-700 shadow-sm border border-slate-200 dark:border-slate-600 transition-all duration-200 ease-out ${formData.allergies.status === "true" ? "left-[calc(50%+2px)]" : "left-0.5"
                          }`}
                      />
                      <button
                        type="button"
                        onClick={() => !isDisable && setAllergiesStatus("false")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.allergies.status === "false"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        onClick={() => !isDisable && setAllergiesStatus("true")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.allergies.status === "true"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                  {formData.allergies.status === "true" && (
                    <div className="mt-2 space-y-2">
                      <div className="flex flex-wrap items-end gap-2 p-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-slate-50/50 dark:bg-slate-700/30">
                        <div className="flex-1 min-w-[160px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Allergy type</label>
                          <select
                            value={allergyAddTypeId}
                            onChange={(e) => setAllergyAddTypeId(e.target.value)}
                            disabled={isDisable}
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          >
                            <option value="">Select type</option>
                            {ALLERGY_TYPES.map((t) => (
                              <option key={t.id} value={t.id}>{t.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="flex-1 min-w-[120px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Note</label>
                          <input
                            type="text"
                            value={allergyAddNote}
                            onChange={(e) => setAllergyAddNote(e.target.value)}
                            disabled={isDisable}
                            placeholder="Note..."
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <div className="flex-1 min-w-[100px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Dosage</label>
                          <input
                            type="text"
                            value={allergyAddDosage}
                            onChange={(e) => setAllergyAddDosage(e.target.value)}
                            disabled={isDisable}
                            placeholder="e.g. 500mg"
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <div className="flex-1 min-w-[120px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">When diagnosed</label>
                          <input
                            type="text"
                            value={allergyAddDiagnosedWhen}
                            onChange={(e) => setAllergyAddDiagnosedWhen(e.target.value)}
                            disabled={isDisable}
                            placeholder="e.g. 2020 or Jan 2020"
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={addAllergyEntry}
                          disabled={isDisable || !allergyAddTypeId}
                          className="h-8 px-4 rounded-md bg-primary text-white text-xs font-medium hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Add
                        </button>
                      </div>
                      <div className="overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-600">
                        <table className="w-full text-left text-sm">
                          <thead>
                            <tr className="border-b border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50">
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 whitespace-nowrap">#</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300">Allergy type</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[120px]">Note</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[90px]">Dosage</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[100px]">When diagnosed</th>
                              {!isDisable && (
                                <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 w-12"></th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {formData.allergies.items.length === 0 ? (
                              <tr>
                                <td colSpan={isDisable ? 5 : 6} className="px-3 py-4 text-center text-slate-500 dark:text-slate-400 text-xs">
                                  No allergies added. Use the form above to add.
                                </td>
                              </tr>
                            ) : (
                              formData.allergies.items.map((row, index) => (
                                <tr
                                  key={`${row.id}-${index}`}
                                  className="border-b border-slate-100 dark:border-slate-600/50 last:border-0"
                                >
                                  <td className="px-3 py-1.5 text-slate-600 dark:text-slate-400">{index + 1}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.label}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.note || "—"}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.dosage || "—"}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.diagnosedWhen || "—"}</td>
                                  {!isDisable && (
                                    <td className="px-3 py-1.5">
                                      <button
                                        type="button"
                                        onClick={() => removeAllergyEntry(index)}
                                        className="text-red-500 hover:text-red-600 text-xs"
                                        aria-label="Remove"
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                {/* Diabetes mellitus - Drugs: Yes/No → when Yes, select + note + Add → table */}
                <div className="flex flex-col gap-2.5 mb-5">
                  <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                    Diabetes mellitus – Drugs
                  </label>
                  <div className="flex items-center gap-5">
                    <div
                      role="group"
                      aria-label="Diabetes mellitus drugs - Yes or No"
                      className={`relative inline-flex p-0.5 rounded-lg border bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-600 ${isDisable ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                    >
                      <div
                        className={`absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-md bg-white dark:bg-slate-700 shadow-sm border border-slate-200 dark:border-slate-600 transition-all duration-200 ease-out ${formData.diabetesMellitusDrugs.status === "true" ? "left-[calc(50%+2px)]" : "left-0.5"
                          }`}
                      />
                      <button
                        type="button"
                        onClick={() => !isDisable && setDiabetesDrugsStatus("false")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.diabetesMellitusDrugs.status === "false"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        onClick={() => !isDisable && setDiabetesDrugsStatus("true")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.diabetesMellitusDrugs.status === "true"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                  {formData.diabetesMellitusDrugs.status === "true" && (
                    <div className="mt-2 space-y-2">
                      <div className="flex flex-wrap items-end gap-2 p-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-slate-50/50 dark:bg-slate-700/30">
                        <div className="flex-1 min-w-[160px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Drug</label>
                          <select
                            value={diabetesDrugAddTypeId}
                            onChange={(e) => setDiabetesDrugAddTypeId(e.target.value)}
                            disabled={isDisable}
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          >
                            <option value="">Select drug</option>
                            {DIABETES_DRUG_TYPES.map((t) => (
                              <option key={t.id} value={t.id}>{t.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="flex-1 min-w-[120px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Note</label>
                          <input
                            type="text"
                            value={diabetesDrugAddNote}
                            onChange={(e) => setDiabetesDrugAddNote(e.target.value)}
                            disabled={isDisable}
                            placeholder="Note..."
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <div className="flex-1 min-w-[100px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Dosage</label>
                          <input
                            type="text"
                            value={diabetesDrugAddDosage}
                            onChange={(e) => setDiabetesDrugAddDosage(e.target.value)}
                            disabled={isDisable}
                            placeholder="e.g. 500mg BD"
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <div className="flex-1 min-w-[120px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">When diagnosed</label>
                          <input
                            type="text"
                            value={diabetesDrugAddDiagnosedWhen}
                            onChange={(e) => setDiabetesDrugAddDiagnosedWhen(e.target.value)}
                            disabled={isDisable}
                            placeholder="e.g. 2020 or Jan 2020"
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={addDiabetesDrugEntry}
                          disabled={isDisable || !diabetesDrugAddTypeId}
                          className="h-8 px-4 rounded-md bg-primary text-white text-xs font-medium hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Add
                        </button>
                      </div>
                      <div className="overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-600">
                        <table className="w-full text-left text-sm">
                          <thead>
                            <tr className="border-b border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50">
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 whitespace-nowrap">#</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300">Drug</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[120px]">Note</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[90px]">Dosage</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[100px]">When diagnosed</th>
                              {!isDisable && (
                                <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 w-12"></th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {formData.diabetesMellitusDrugs.items.length === 0 ? (
                              <tr>
                                <td colSpan={isDisable ? 5 : 6} className="px-3 py-4 text-center text-slate-500 dark:text-slate-400 text-xs">
                                  No drugs added. Use the form above to add.
                                </td>
                              </tr>
                            ) : (
                              formData.diabetesMellitusDrugs.items.map((row, index) => (
                                <tr
                                  key={`${row.id}-${index}`}
                                  className="border-b border-slate-100 dark:border-slate-600/50 last:border-0"
                                >
                                  <td className="px-3 py-1.5 text-slate-600 dark:text-slate-400">{index + 1}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.label}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.note || "—"}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.dosage || "—"}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.diagnosedWhen || "—"}</td>
                                  {!isDisable && (
                                    <td className="px-3 py-1.5">
                                      <button
                                        type="button"
                                        onClick={() => removeDiabetesDrugEntry(index)}
                                        className="text-red-500 hover:text-red-600 text-xs"
                                        aria-label="Remove"
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                {/* Hypertension - Drugs: Yes/No → when Yes, select + note only + Add → table */}
                <div className="flex flex-col gap-2.5 mb-5">
                  <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                    Hypertension – Drugs
                  </label>
                  <div className="flex items-center gap-5">
                    <div
                      role="group"
                      aria-label="Hypertension drugs - Yes or No"
                      className={`relative inline-flex p-0.5 rounded-lg border bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-600 ${isDisable ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                    >
                      <div
                        className={`absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-md bg-white dark:bg-slate-700 shadow-sm border border-slate-200 dark:border-slate-600 transition-all duration-200 ease-out ${formData.hypertensionDrugs.status === "true" ? "left-[calc(50%+2px)]" : "left-0.5"
                          }`}
                      />
                      <button
                        type="button"
                        onClick={() => !isDisable && setHypertensionDrugsStatus("false")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.hypertensionDrugs.status === "false"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        onClick={() => !isDisable && setHypertensionDrugsStatus("true")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.hypertensionDrugs.status === "true"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                  {formData.hypertensionDrugs.status === "true" && (
                    <div className="mt-2 space-y-2">
                      <div className="flex flex-wrap items-end gap-2 p-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-slate-50/50 dark:bg-slate-700/30">
                        <div className="flex-1 min-w-[200px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Drug</label>
                          <select
                            value={hypertensionDrugAddTypeId}
                            onChange={(e) => setHypertensionDrugAddTypeId(e.target.value)}
                            disabled={isDisable}
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          >
                            <option value="">Select drug</option>
                            {HYPERTENSION_DRUG_TYPES.map((t) => (
                              <option key={t.id} value={t.id}>{t.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="flex-1 min-w-[160px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Note</label>
                          <input
                            type="text"
                            value={hypertensionDrugAddNote}
                            onChange={(e) => setHypertensionDrugAddNote(e.target.value)}
                            disabled={isDisable}
                            placeholder="Add note..."
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={addHypertensionDrugEntry}
                          disabled={isDisable || !hypertensionDrugAddTypeId}
                          className="h-8 px-4 rounded-md bg-primary text-white text-xs font-medium hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Add
                        </button>
                      </div>
                      <div className="overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-600">
                        <table className="w-full text-left text-sm">
                          <thead>
                            <tr className="border-b border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50">
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 whitespace-nowrap">#</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300">Drug</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[160px]">Note</th>
                              {!isDisable && (
                                <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 w-12"></th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {formData.hypertensionDrugs.items.length === 0 ? (
                              <tr>
                                <td colSpan={isDisable ? 3 : 4} className="px-3 py-4 text-center text-slate-500 dark:text-slate-400 text-xs">
                                  No drugs added. Use the form above to add.
                                </td>
                              </tr>
                            ) : (
                              formData.hypertensionDrugs.items.map((row, index) => (
                                <tr
                                  key={`${row.id}-${index}`}
                                  className="border-b border-slate-100 dark:border-slate-600/50 last:border-0"
                                >
                                  <td className="px-3 py-1.5 text-slate-600 dark:text-slate-400">{index + 1}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.label}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.note || "—"}</td>
                                  {!isDisable && (
                                    <td className="px-3 py-1.5">
                                      <button
                                        type="button"
                                        onClick={() => removeHypertensionDrugEntry(index)}
                                        className="text-red-500 hover:text-red-600 text-xs"
                                        aria-label="Remove"
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                {/* Dyslipidemia: Yes/No → when Yes, select + note + Add → table */}
                <div className="flex flex-col gap-2.5 mb-5">
                  <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                    Dyslipidemia
                  </label>
                  <div className="flex items-center gap-5">
                    <div
                      role="group"
                      aria-label="Dyslipidemia drugs - Yes or No"
                      className={`relative inline-flex p-0.5 rounded-lg border bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-600 ${isDisable ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                    >
                      <div
                        className={`absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-md bg-white dark:bg-slate-700 shadow-sm border border-slate-200 dark:border-slate-600 transition-all duration-200 ease-out ${formData.dyslipidemiaDrugs.status === "true" ? "left-[calc(50%+2px)]" : "left-0.5"
                          }`}
                      />
                      <button
                        type="button"
                        onClick={() => !isDisable && setDyslipidemiaDrugsStatus("false")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.dyslipidemiaDrugs.status === "false"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        onClick={() => !isDisable && setDyslipidemiaDrugsStatus("true")}
                        disabled={isDisable}
                        className={`relative z-10 w-14 py-1.5 text-[13px] font-medium rounded-md transition-colors duration-200 ${formData.dyslipidemiaDrugs.status === "true"
                          ? "text-slate-800 dark:text-slate-100"
                          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                          } ${isDisable ? "cursor-not-allowed" : "cursor-pointer"}`}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                  {formData.dyslipidemiaDrugs.status === "true" && (
                    <div className="mt-2 space-y-2">
                      <div className="flex flex-wrap items-end gap-2 p-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-slate-50/50 dark:bg-slate-700/30">
                        <div className="flex-1 min-w-[180px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Drug</label>
                          <select
                            value={dyslipidemiaDrugAddTypeId}
                            onChange={(e) => setDyslipidemiaDrugAddTypeId(e.target.value)}
                            disabled={isDisable}
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          >
                            <option value="">Select drug</option>
                            {DYSLIPIDEMIA_DRUG_TYPES.map((t) => (
                              <option key={t.id} value={t.id}>{t.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="flex-1 min-w-[160px]">
                          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Note</label>
                          <input
                            type="text"
                            value={dyslipidemiaDrugAddNote}
                            onChange={(e) => setDyslipidemiaDrugAddNote(e.target.value)}
                            disabled={isDisable}
                            placeholder="Add note..."
                            className="w-full h-8 px-3 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={addDyslipidemiaDrugEntry}
                          disabled={isDisable || !dyslipidemiaDrugAddTypeId}
                          className="h-8 px-4 rounded-md bg-primary text-white text-xs font-medium hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Add
                        </button>
                      </div>
                      <div className="overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-600">
                        <table className="w-full text-left text-sm">
                          <thead>
                            <tr className="border-b border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50">
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 whitespace-nowrap">#</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300">Drug</th>
                              <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 min-w-[160px]">Note</th>
                              {!isDisable && (
                                <th className="px-3 py-2 font-medium text-slate-700 dark:text-slate-300 w-12"></th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {formData.dyslipidemiaDrugs.items.length === 0 ? (
                              <tr>
                                <td colSpan={isDisable ? 3 : 4} className="px-3 py-4 text-center text-slate-500 dark:text-slate-400 text-xs">
                                  No drugs added. Use the form above to add.
                                </td>
                              </tr>
                            ) : (
                              formData.dyslipidemiaDrugs.items.map((row, index) => (
                                <tr
                                  key={`${row.id}-${index}`}
                                  className="border-b border-slate-100 dark:border-slate-600/50 last:border-0"
                                >
                                  <td className="px-3 py-1.5 text-slate-600 dark:text-slate-400">{index + 1}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.label}</td>
                                  <td className="px-3 py-1.5 text-slate-700 dark:text-slate-200">{row.note || "—"}</td>
                                  {!isDisable && (
                                    <td className="px-3 py-1.5">
                                      <button
                                        type="button"
                                        onClick={() => removeDyslipidemiaDrugEntry(index)}
                                        className="text-red-500 hover:text-red-600 text-xs"
                                        aria-label="Remove"
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <RadioInput
                  isDisable={isDisable}
                  name="gastricProblem"
                  value={formData.gastricProblem}
                  onChange={handleChange}
                  label="Gastric Problem"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="highBP"
                  onChange={handleChange}
                  label="High Blood Pressure"
                  value={formData.highBP}
                />
                <RadioInput
                  isDisable={isDisable}
                  name="diabetes"
                  value={formData.diabetes}
                  onChange={handleChange}
                  label="Diabetes"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="monthlyInjection"
                  value={formData.monthlyInjection}
                  onChange={handleChange}
                  label="Monthly Injection (History of Rheumatic fever)"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="pregnancyBreastFeeding"
                  value={formData.pregnancyBreastFeeding}
                  onChange={handleChange}
                  label="Pregnancy / Breast Feeding"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="coughColdFever"
                  value={formData.coughColdFever}
                  onChange={handleChange}
                  label="Cough / Cold / Fever"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="chestpainHeartProblem"
                  value={formData.chestpainHeartProblem}
                  onChange={handleChange}
                  label="History Of (MI) Chest pain. High pressure & Heart Problem"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="epilepsy"
                  value={formData.epilepsy}
                  onChange={handleChange}
                  label="Epilepsy"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="previousExtraction"
                  value={formData.previousExtraction}
                  onChange={handleChange}
                  label="Previous Extraction"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="previoussurgeries"
                  value={formData.previoussurgeries}
                  onChange={handleChange}
                  label="Previous Surgeries"
                />
              </div>

              {/* Right Column */}
              <div className="space-y-3">


                <RadioInput
                  isDisable={isDisable}
                  name="covid193Doses"
                  value={formData.covid193Doses}
                  onChange={handleChange}
                  label="COVID19 (3 Doses)"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="drugHistory"
                  value={formData.drugHistory}
                  onChange={handleChange}
                  label="Drug History"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="dietaryHistory"
                  value={formData.dietaryHistory}
                  onChange={handleChange}
                  label="Dietary History"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="brushingHistory"
                  value={formData.brushingHistory}
                  onChange={handleChange}
                  label="Brushing History"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="medicalHistoryNote"
                  value={formData.medicalHistoryNote}
                  onChange={handleChange}
                  label="Medical history (note)"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="oralHygieneHistory"
                  value={formData.oralHygieneHistory}
                  onChange={handleChange}
                  label="Oral hygiene history"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="habitHistory"
                  value={formData.habitHistory}
                  onChange={handleChange}
                  label="Habit history"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="familyHistory"
                  value={formData.familyHistory}
                  onChange={handleChange}
                  label="Family history"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="socialHistory"
                  value={formData.socialHistory}
                  onChange={handleChange}
                  label="Social history"
                />
                <InputText
                  isDisable={isDisable}
                  name="extraOralExamination"
                  value={formData.extraOralExamination}
                  onChange={handleChange}
                  label="Extra Oral Examination"
                />
                <InputText
                  isDisable={isDisable}
                  name="intraOralExamination"
                  value={formData.intraOralExamination}
                  onChange={handleChange}
                  label="Intra Oral Examination"
                />
              </div>
            </div>
          )}
        </div>

        {/* Form Actions */}
        <div
          className="flex justify-end gap-2 mt-3 pt-3 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        >
          {selectNavigate === 0 ? null : (
            <button
              type="button"
              onClick={() => handleSelectNavugate(0)}
              className="flex items-center gap-1.5 px-4 py-2 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-lg font-medium text-xs hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors"
            >
              <ArrowBackIcon sx={{ fontSize: 16 }} />
              Back
            </button>
          )}
          {selectNavigate === 0 ? (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSelectNavugate(1);
              }}
              className="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium text-xs hover:shadow-lg hover:shadow-primary/30 transition-all"
            >
              Next
              <ArrowForwardIcon sx={{ fontSize: 16 }} />
            </button>
          ) : ID ? (
            !isDisable && (
              <button
                type="submit"
                className="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium text-xs hover:shadow-lg hover:shadow-primary/30 transition-all"
              >
                <SaveIcon sx={{ fontSize: 16 }} />
                Update
              </button>
            )
          ) : (
            <button
              type="submit"
              className="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium text-xs hover:shadow-lg hover:shadow-primary/30 transition-all"
            >
              <SaveIcon sx={{ fontSize: 16 }} />
              Register
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default FullregisterPatient;
